import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import ControlBar from './ControlBar'
import PageContent from './PageContent'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import Modal from '../../../components/structure/Modal'
import PageHeader from './PageHeader'
import ControlledModal from '../../../components/modals/ControlledModal'

const ServiceOrdersPublicHistoryModal = props => {
  return (
    <Modal width="84rem" open={true} onClick={() => ({})}>
      <PageHeader />
      <PageContent />
      <Separator weight={32} />
    </Modal>
  )
}

export default ServiceOrdersPublicHistoryModal
